import {
    faAngleUp,
    faCaretDown,
    faCheck,
    faCircle,
    faCircleSmall,
    faCircleStar,
    faCircleUser,
    faEllipsis,
    faEllipsisVertical,
    faImages,
    faLockKeyhole,
    faLockKeyholeOpen,
    faShoppingBasket,
    faSquare,
    faText,
    faUser,
    faUserSecret,
    type IconDefinition,
} from "@fortawesome/pro-solid-svg-icons";

export const solidIcons: IconDefinition[] = [
    faAngleUp,
    faCaretDown,
    faCheck,
    faCircle,
    faCircleSmall,
    faCircleStar,
    faCircleUser,
    faEllipsis,
    faEllipsisVertical,
    faImages,
    faLockKeyhole,
    faLockKeyholeOpen,
    faShoppingBasket,
    faSquare,
    faText,
    faUser,
    faUserSecret,
];
